module.exports = __webpack_public_path__ + "img/9blue.a78532df.png";